'use strict'

import Vue from 'vue'

import Hello from 'src/components/Hello.vue'

const Page404 = { template: '<div>404</div>' }

const baseSlash = document.getElementsByTagName('base')[0].href || '/'

export default [
  {
    path: '/',
    name: 'Hello',
    beforeEnter: (to, from, next) => {
      next('/home')
    },
    component: Hello
  },
  { path: '/404', component: Page404 },
  {
    path: '/bay',
    // path: '/landing',
    name: 'Landing',
    beforeEnter: (to, from, next) => {
      // name null if no from route
      (from.name !== null ? next({ path: '/forceLanding' }) : next())
    },
    component: Page404
  },
  {
    path: '/landing',
    redirect: '/bay',
  },
  {
    path: '/forceLanding',
    name: 'ForceLanding',
    beforeEnter: () => {
      window.location.href = baseSlash + 'bay' // 'bay' is alias for 'landing'
    },
    component: Page404
  },
  {
    path: '/forceHome',
    name: 'forceHome',
    beforeEnter: () => {
      window.location.href = baseSlash + 'home'
    },
    component: Page404
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter: (to, from, next) => {
      if (from.name === null) {
        next({ path: '/forceLanding' })
      } else {
        import('src/components/Login/js/logout.js')
          .then(m => m.default)
          .then(logout => {
            logout()
              .then(() => {
                next({ path: '/forceLanding' })
              })
          })
      }
    },
    component: Page404,
  },
  {
    path: '/index',
    name: 'index',
    beforeEnter: (to, from, next) => {
      next('/home')
    },
    component: Page404
  },
  {
    path: '/webpack',
    name: 'Webpack',
    beforeEnter: (to, from, next) => {
      next('/research/projects')
    },
    component: Page404
  },
  {
    path : '/app_layout_simple',
    name : 'app_layout_simple',
    components : {
      default: () => import(`src/components/App/AppLayoutSimple.vue`),
    },
    children : [
      {
        path : '/stripeTest',
        name : 'stripe_test',
        components : {
          default : () => import('src/components/Stripe/Test.vue'),
        },
      },
      {
        path : '/checkout/:key(.+)',
        name : 'checkout',
        components : {
          default : () => import('src/components/Checkout/Checkout.vue'),
        },
      },
      {
        path : '/createOrder',
        name : 'create_order',
        components : {
          default : () => import('src/components/Orders/CreateOrder.vue'),
        },
      },
      {
        path : '/viewOrder/:key(.+)',
        name : 'view_order',
        components : {
          default : () => import('src/components/Orders/ViewOrderPage.vue'),
        },
      },
      {
        path : '/upgradePlan',
        name : 'upgrade_plan',
        components : {
          default : () => import('src/components/PayPlan/UpgradePlan.vue'),
        },
      },
      {
        path : '/choosePlanTabs',
        name : 'choose_plan_tabs',
        components : {
          default : () => import('src/components/PayPlan/ChoosePlanTabs.vue'),
        },
        children : [
          {
            path : '/choosePlan',
            name : 'choose_plan',
            components : {
              default : () => import('src/components/PayPlan/ChoosePlan.vue'),
            },
          },
          {
            path : '/choosePlanEnterprise',
            name : 'choose_plan_enterprise',
            components : {
              default : () => import('src/components/PayPlan/ChoosePlanEnterprise.vue'),
            },
          },
        ],
      },
      {
        path : '/layout_box',
        name : 'layout_box',
        meta : {

        },
        components : {
          header : () => import(`src/components/PagesBox/TopMenu.vue`),
          default: () => import(`src/components/PagesBox/Layout.vue`),
          footer : () => import(`src/components/PagesBox/Footer.vue`),
        },
        children : [
          {
            path : '/box',
            name : 'box',
            components : {
              default: () => import(`src/components/PagesBox/PageHome/index.vue`),
            },
          },
          {
            path : '/box/login',
            name : 'box_login',
            meta : {
              toolbarAbsolute : true,
              showFooter : false,
              hideMenuDesktop : true,
            },
            components : {
              header : () => import(`src/components/PagesBox/TopMenuEmpty.vue`),
              default: () => import(`src/components/Login/LoginPage.vue`),
            },
          },
          {
            path : '/box/config',
            name : 'box_config',
            meta : {
              requireAuth : true,
            },
            components : {
              default: () => import(`src/components/PagesBox/PageConfig/index.vue`),
            },
          },
          {
            path : '/box/technology',
            name : 'box_technology',
            components : {
              default: () => import(`src/components/PagesBox/PageTechnology/index.vue`),
            },
          },
          {
            path : '/box/industry',
            name : 'box_industry',
            components : {
              default: () => import(`src/components/PagesBox/PageIndustries/index.vue`),
            },
          },
          {
            path : '/box/about',
            name : 'box_about',
            components : {
              default: () => import(`src/components/PagesBox/PageAbout/index.vue`),
            },
          },
          {
            path : '/box/contact',
            name : 'box_contact',
            components : {
              default: () => import(`src/components/PagesBox/PageContact/index.vue`),
            },
          },
          {
            path: '/box/news/:item_id',
            components: {
              default: () => import(`src/components/PagesBox/PageNews.vue`)
            },
          },
          {
            path: '/box/jobs/:item_id',
            components: {
              default: () => import(`src/components/PagesBox/PageJobs.vue`)
            },
          },
        ],
      },
    ],
  },
  {
    path : '/app_layout_default',
    name : 'app_layout_default',
    components : {
      background : () => import(`src/components/App/AppBg.vue`),
      default: () => import(`src/components/App/AppLayoutDefault.vue`),
    },
    children : [
      {
        path: '/info',
        name: 'info',
        components: {
          // header : () => import(`src/components/TopMenu/TopMenu.vue`),
          header : () => import(`src/components/TopMenu/TopMenuOuter.vue`),
          default: () => import(`src/components/layout/LayoutDefault.vue`),
        },
        children: [
          {
            path: ':pageName',
            components: {
              default: () => import(`src/components/pages/info/StaticPage.vue`)
            }
          }
        ]
      },
      {
        path : '/layout_default_inner',
        name : 'layout_default_inner',
        meta : {
          topMenuLayout : 'inner',
          requireAuth : true,
          showPageBg : true,
          mobileToolbarFixedHeight : true,
          navLeft : true,
          navRight : true,
        },
        components : {
          // navLeft : () => import(`src/components/Navigation/NavToolsWrap.vue`),
          navLeft : () => import(`src/components/Navigation/NavFeedStreamWrap.vue`),
          navRight : () => import(`src/components/Navigation/NavRightWrap.vue`),
          // header : () => import(`src/components/TopMenu/TopMenuOld.vue`),
          header : () => import(`src/components/TopLine/TopLine.vue`),
          default : () => import(`src/components/layout/LayoutDefault.vue`),
        },
        children : [
          {
            path: '/home',
            name: 'home',
            components: {
              default : () => import(`src/components/Home/HomeDefault.vue`),
            },
            beforeEnter: (to, from, next) => {
              const goNext = userType => {
                switch (userType) {
                  case 'landing_config':
                    next('/landingConfig')
                    break
                  case 'dealmaker':
                    next('/deals')
                    break
                  default:
                    next()
                }
              }

              try {
                let user = JSON.parse(window.localStorage.getItem('currentUser'))

                if (user) {
                  goNext(user.user_type)
                } else {
                  Vue.http.post('mod/api_simple/getCurrentUser')
                    .then((resp) => {
                      goNext(resp.body.user.user_type)
                    })
                    .catch(() => {
                      goNext()
                    })
                }
              } catch (err) {
                console.log(err)
                goNext()
              }
            },
          },
          {
            path: '/home/feed/:item_id(\\d+)?',
            name: 'homeFeed',
            components: {
              default : () => import(`src/components/Home/HomeDefault.vue`),
            },
          },
          {
            path: '/home/chat',
            name: 'homeChat',
            components: {
              default : () => import(`src/components/Home/HomeDefault.vue`),
            },
            props : {
              default : {
                content : 'chat',
              },
            },
          },
          {
            path: '/home/chat/:streamType/:streamId(\\d+)',
            name: 'homeStream',
            components: {
              default : () => import(`src/components/Home/HomeDefault.vue`),
            },
            props : {
              default : route => ({
                content : {
                  type : 'stream',
                  streamType : route.params.streamType,
                  streamId : route.params.streamId,
                }
              })
            },
          },
          {
            path: '/groups',
            name: 'groups',
            meta : {
              searchLocation : 'groups',
            },
            components: {
              default : () => import(`src/components/Groups/ListPage.vue`),
            }
          },
          {
            path: '/projects',
            name: 'projects',
            meta : {
              searchLocation : 'projects',
            },
            components: {
              default : () => import(`src/components/Projects/ListPage.vue`),
            }
          },
          {
            path: '/project/:pid/notes',
            name: 'projectNotes',
            components: {
              default : () => import(`src/components/Projects/SubitemsNotes.vue`),
            }
          },
          {
            path: '/project/:pid/tasks',
            name: 'projectTasks',
            components: {
              default : () => import(`src/components/Projects/SubitemsTasks.vue`),
            }
          },
          {
            path: '/tasks',
            name: 'tasks',
            meta : {
              searchLocation : 'tasks',
            },
            components: {
              default : () => import(`src/components/Tasks/ListPage.vue`),
            }
          },
          {
            path: '/notes',
            name: 'notes',
            meta : {
              searchLocation : 'notes',
            },
            components: {
              default : () => import(`src/components/Notes/ListPage.vue`),
            }
          },
          {
            path: '/notes/types',
            name: 'notesTypes',
            components: {
              default : () => import(`src/components/Notes/NoteTypeListPage.vue`),
            }
          },
          {
            path: '/deals',
            meta : {
              searchLocation : 'deals',
            },
            components: {
              default : () => import(`src/components/Notes/DealsListPage.vue`),
            }
          },
          {
            path: '/note_templates',
            components: {
              default : () => import(`src/components/Notes/TemplatesListPage.vue`),
            }
          },
          {
            path: '/custom_doc_master',
            name: 'custom_doc_master',
            components: {
              default : () => import(`src/components/CustomDocMaster/ListPage.vue`),
            }
          },
          {
            path: '/custom_doc/:docName',
            name: 'custom_doc',
            meta : {
              showToolbar : false,
            },
            components: {
              default : () => import(`src/components/CustomDoc/ListPage.vue`),
            },
          },
          {
            path: '/orders',
            name: 'orders',
            components: {
              default : () => import(`src/components/Orders/ListPage.vue`),
            }
          },
          {
            path: '/contacts',
            name: 'contacts',
            meta : {
              searchLocation : 'contacts',
            },
            components: {
              default : () => import(`src/components/Contacts/ListPage.vue`),
            }
          },
          {
            path: '/profile',
            components: {
              default : () => import(`src/components/Profile/Profile.vue`),
            },
          },
          {
            path : '/profile/:item_id(\\d+)?/edit',
            name : 'profileEdit',
            components : {
              default : () => import(`src/components/Profile/ProfileEdit.vue`),
            },
          },
          {
            path : '/config',
            name : 'config',
            components :  {
              default : () => import(`src/components/Config/ConfigPage.vue`)
            },
          },
          {
            path : '/applicants',
            name : 'applicants',
            components :  {
              default : () => import(`src/components/Applicants/ApplicantsList.vue`)
            },
          },
          {
            path : '/sites',
            name : 'sites',
            components :  {
              default : () => import(`src/components/FnSites/FnSitesList.vue`)
            },
          },
          {
            path : '/files',
            name : 'files',
            meta : {
              searchLocation : 'files',
            },
            components :  {
              default : () => import(`src/components/FileManager/FilesList.vue`)
            },
          },
          {
            path : '/payoneer',
            name : 'payoneer',
            components :  {
              default : () => import(`src/components/Payoneer/PayoneerPage.vue`)
            },
          },
        ]
      },
      {
        path : '/layout_default_inner_outer',
        name : 'layout_default_inner_outer',
        meta : {
          topMenuLayout : 'inner',
          requireAuth : false,
          showPageBg : true,
          mobileToolbarFixedHeight : true,
          navLeft : true,
          navRight : true,
        },
        components : {
          navLeft : () => import(`src/components/Navigation/NavToolsWrap.vue`),
          navRight : () => import(`src/components/Navigation/NavRightWrap.vue`),
          header : () => import(`src/components/TopMenu/TopMenuOld.vue`),
          // header : () => import(`src/components/TopLine/TopLine.vue`),
          default : () => import(`src/components/layout/LayoutDefault.vue`),
        },
        children : [
          {
            path: '/profile/:item_id(\\d+)?',
            name: 'profile',
            components: {
              default : () => import(`src/components/Profile/Profile.vue`),
            },
          },
          {
            path: '/project/:pid/pixel',
            name: 'projectPixel',
            components: {
              default : () => import(`src/components/Projects/PixelMap.vue`),
            }
          },
          {
            path: '/projects/pixelmap/:pid',
            name: 'projectPixelOld',
            components: {
              default : () => import(`src/components/Projects/PixelMap.vue`),
            }
          },
        ],
      },
      {
        path : '/layout_default_outer_mini',
        name : 'layout_default_outer_mini',
        meta : {
          topMenuLayout : 'outerMini',
        },
        components : {
          header : () => import(`src/components/TopMenu/TopMenuOuter.vue`),
          default : () => import(`src/components/layout/LayoutDefault.vue`),
        },
        children : [
          {
            path: '/note/:item_id',
            meta : {
              mobileMenuBtnShow : false,
            },
            components: {
              default: () => import(`src/components/Notes/NoteLanding.vue`)
            },
          },
          {
            path: '/task/:item_id',
            components: {
              default: () => import(`src/components/Tasks/TaskLanding.vue`)
            },
          },
          {
            path : '/linkExpired',
            name : 'linkExpired',
            components : {
              default : () => import(`src/components/pages/LinkExpired.vue`),
            },
          },
          {
            path : '/privacy-policy',
            name : 'privacyPolicy',
            components : {
              default : () => import(`src/components/pages/PrivacyPolicy.vue`),
            },
          },
        ],
      },
      {
        path : '/layout_minimal',
        name : 'layout_minimal',
        meta : {
          topMenuLayout : 'logoOnly',
          toolbarAbsolute : true,
        },
        components : {
          header : () => import(`src/components/TopMenu/TopMenuOuter.vue`),
          default : () => import(`src/components/layout/LayoutDefault.vue`),
        },
        children : [
          {
            path : '/login',
            meta : {
              logoOrTextForceLogo : true,
              mobileHideLogo : true,
            },
            components : {
              default : () => import(`src/components/Login/LoginPage.vue`),
            },
          },
          {
            path : '/loginLeft',
            meta : {
              alignLoginLeft : true,
            },
            components : {
              default : () => import(`src/components/Login/LoginPage.vue`),
            },
          },
          {
            path : '/apply',
            components : {
              default : () => import(`src/components/Applicants/ApplyPage.vue`),
            },
          },
        ],
      },
      {
        path : '/layout_logo_logout',
        name : 'layout_logo_logout',
        meta : {
          topMenuLayout : 'logoAndLogout',
          toolbarAbsolute : true,
        },
        components : {
          header : () => import(`src/components/TopMenu/TopMenuMinimal.vue`),
          default : () => import(`src/components/layout/LayoutDefault.vue`),
        },
        children : [],
      },
      {
        path : '/layout_logout',
        name : 'layout_logout',
        meta : {
          topMenuLayout : 'logout',
          toolbarAbsolute : true,
        },
        components : {
          header : () => import(`src/components/TopMenu/TopMenuMinimal.vue`),
          default : () => import(`src/components/layout/LayoutDefault.vue`),
        },
        children : [
          {
            path : '/landingConfig',
            components : {
              default : () => import(`src/components/Config/ConfigLandingPage.vue`),
            },
          },
        ],
      },
      {
        path : '/layout_default',
        name : 'layout_default',
        meta : {
          topMenuLayout : 'research',
          // navLeft : true,
        },
        components : {
          // navLeft : () => import(`src/components/Navigation/NavOuter.vue`),
          header : () => import(`src/components/TopMenu/TopMenuOuter.vue`),
          default : () => import(`src/components/layout/LayoutDefault.vue`),
        },
        children : [
          {
            path: '/research',
            components: {
              default: () => import(`src/components/Research/Research.vue`)
            },
            children : [
              {
                path : 'all',
                components : {
                  default: () => import(`src/components/Research/All.vue`)
                }
              },
              {
                path : 'projects',
                components : {
                  default: () => import(`src/components/Research/Projects.vue`)
                }
              },
              {
                path : 'groups',
                components : {
                  default: () => import(`src/components/Research/Groups.vue`)
                }
              },
            ],
          },
          {
            path: '/group/:item_id',
            components: {
              default: () => import(`src/components/Groups/GroupLanding.vue`)
            },
          },
          {
            path: '/project/:item_id',
            components: {
              default: () => import(`src/components/Projects/ProjectLanding.vue`)
            },
          },
        ]
      },
      {
        path : '/layout_default_alone',
        name : 'layout_default_alone',
        meta : {
          showToolbar : false,
        },
        components : {
          default : () => import(`src/components/layout/LayoutDefaultAlone.vue`),
        },
        children : [
          {
            path: '/chat/msg/:msg_id',
            name: 'ChatMsg',
            components: {
              default : () => import(`src/components/Chat/ChatMsgPage.vue`),
            },
          },
          {
            path: '/chat/stream/:streamType/:streamId(\\d+)',
            name: 'ChatStream',
            components: {
              default : () => import(`src/components/Chat/ChatStreamPage.vue`),
            },
          },
          {
            path: '/chat/stream/:streamType(\\w+)_:streamId(\\d+)',
            name: 'ChatStreamOld',
            components: {
              default : () => import(`src/components/Chat/ChatStreamPage.vue`),
            },
          },
          {
            path: '/files_folder/:mountType/:mountId/:parentDir',
            name: 'FilesListAlone',
            components: {
              default : () => import(`src/components/FileManager/FilesListAlonePage.vue`),
            },
          },
        ],
      },
      {
        path : '/layout_landing',
        name : 'layout_landing',
        meta : {
          topMenuLayout : 'landing',
          mobileMenuLayout : 'navOuterLanding',
          toolbarAbsolute : true,
        },
        components : {
          header : () => import(`src/components/TopMenu/TopMenuLanding.vue`),
          default : () => import('src/components/Landing/LandingLayout.vue'),
        },
        children : [
          {
            path : '/oat',
            meta : {
              toolbarFixedHack : true,
              isBgDark : true,
            },
            components : {
              default : () => import('src/components/Landing/Landing.vue'),
            },
          },
          {
            path: '/landingCustom',
            redirect: '/oat',
          },
          {
            path: '/pass_restore',
            beforeEnter (to, from, next) {
              let route = {
                path : '/login',
                query : {
                  modal : 'pass_restore',
                },
              }

              if (to.query.code) route.query.code = to.query.code

              next(route)
            },
          }
        ],
      },
      {
        path : '/layout_zoe_ph',
        name : 'layout_zoe_ph',
        meta : {
          topMenuLayout : 'zoe',
          toolbarAbsolute : true,
        },
        components : {
          header : () => import(`src/components/PagesZoe/comp/TopMenuTemp.vue`),
          default : () => import(`src/components/PagesZoe/Layout.vue`),
        },
        children : [
          {
            path : '/uno',
            meta : {
              toolbarFixed : true,
            },
            components : {
              default : () => import(`src/components/PagesZoe/comp/LandingPlaceholder.vue`),
            },
          },
        ],
      },
      {
        path : '/layout_zoe',
        name : 'layout_zoe',
        meta : {
          topMenuLayout : 'empty',
          toolbarFixed : true,
          mobileToolbarFixedHeight : true,
          toolbarHeight : 100,
        },
        components : {
          header : () => import(`src/components/PagesZoe/TopMenu.vue`),
          // header : () => import(`src/components/TopMenu/TopMenuOuter.vue`),
          default : () => import(`src/components/PagesZoe/Layout.vue`),
          // footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
        },
        children : [
          {
            path : '/zoe',
            components : {
              default : () => import(`src/components/PagesZoe/Landing.vue`),
            },
          },
          {
            path : '/zoe/about',
            components : {
              default : () => import(`src/components/PagesZoe/About.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
          },
          {
            path : '/zoe/team',
            components : {
              default : () => import(`src/components/PagesZoe/Team.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
          },
          {
            path : '/zoe/team/:id',
            alias : '/zoe/person/:id',
            components : {
              default : () => import(`src/components/PagesZoe/comp/Team/Person.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
          },
          {
            path : '/zoe/invest',
            components : {
              default : () => import(`src/components/PagesZoe/Invest.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
          },
          {
            path : '/zoe/contact',
            components : {
              default : () => import(`src/components/PagesZoe/Contact.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
          },
          {
            path : '/zoe/career',
            components : {
              default : () => import(`src/components/PagesZoe/Career.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
          },
          {
            path : '/zoe/career/:id',
            components : {
              default : () => import(`src/components/PagesZoe/comp/Career/Position.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
          },
          {
            path : '/zoe/social',
            meta : {
              notScrollToTop: true,
            },
            components : {
              default : () => import(`src/components/PagesZoe/Social.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
            children: [
              {
                path: '',
                components: {
                  default:() => import('src/components/PagesZoe/SocialPress.vue'),
                },
              },
              {
                path: 'instagram',
                components: {
                  default:() => import('src/components/PagesZoe/SocialInstagram.vue'),
                },
              },
              {
                path: 'twitter',
                components: {
                  default: () => import('src/components/PagesZoe/SocialTwitter.vue'),
                },
              },
            ],
          },
          {
            path : '/zoe/companies',
            components : {
              default : () => import(`src/components/PagesZoe/Companies.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
          },
          {
            path : '/zoe/companies/:id',
            alias : '/zoe/company/:id',
            components : {
              default : () => import(`src/components/PagesZoe/Company.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
          },
          {
            path : '/zoe/works',
            components : {
              default : () => import(`src/components/PagesZoe/Works.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
          },
          {
            path : '/zoe/works/commercial',
            components : {
              default : () => import(`src/components/PagesZoe/Works1.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
          },
          {
            path : '/zoe/works/fictional',
            components : {
              default : () => import(`src/components/PagesZoe/Works2.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
          },
          {
            path : '/zoe/works/:id',
            alias : '/zoe/work/:id',
            components : {
              default : () => import(`src/components/PagesZoe/Work.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
          },
          {
            path : '/zoe/faq',
            components : {
              default : () => import(`src/components/PagesZoe/Faq.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
          },
          {
            path : '/zoe/legal',
            components : {
              default : () => import(`src/components/PagesZoe/Legal.vue`),
              footer : () => import(`src/components/PagesZoe/comp/Footer.vue`),
            },
          },
        ],
      },
      {
        path      : '/layout_ivy',
        name      : 'layout_ivy',
        meta      : {
          topMenuLayout           : 'empty',
          toolbarFixed            : true,
          mobileToolbarFixedHeight: true,
          toolbarHeight           : 100,
        },
        components: {
          header : () => import(`src/components/PagesIvy/TopMenuBlue.vue`),
          default: () => import(`src/components/PagesIvy/Layout.vue`),
          // footer : () => import(`src/components/PagesIvy/FooterFlying.vue`),
          footer : () => import(`src/components/PagesIvy/Footer.vue`),
        },
        children  : [
          {
            path : '/ivy',
            components : {
              default : () => import(`src/components/PagesIvy/Splash/Page.vue`),
              // default : () => import(`src/components/PagesIvy/Landing.vue`),
            },
          },
          {
            path : '/ivy/landing',
            components : {
              default : () => import(`src/components/PagesIvy/Landing.vue`),
            },
          },
          {
            path : '/ivy/splash',
            components : {
              default : () => import(`src/components/PagesIvy/Splash/Page.vue`),
            },
          },
          {
            path : '/ivy/merger',
            components : {
              default : () => import(`src/components/PagesIvy/Merger/Page.vue`),
            },
          },
          {
            path : '/ivy/technology',
            components : {
              default : () => import(`src/components/PagesIvy/Technology/Page.vue`),
            },
          },
          {
            path : '/ivy/:pageName(\\w+)',
            components : {
              default : () => import(`src/components/PagesIvy/Basic.vue`),
            },
          },
        ],
      },
      {
        path      : '/layout_pea',
        name      : 'layout_pea',
        meta      : {
        },
        components: {
          header : () => import(`src/components/PagesPea/TopMenu.vue`),
          default: () => import(`src/components/PagesPea/Layout.vue`),
          footer : () => import(`src/components/PagesPea/Footer.vue`),
        },
        children: [
          {
            path: '/pea',
            components: {
              default: () => import(`src/components/PagesPea/PageHome/index.vue`),
            },
          },
        ],
      },
    ],
  },
  {
    path: '*',
    name: 'dynamicPage',
    beforeEnter : (to, from, next) => {
      Vue.http.post('mod/custom_url/getTrueUrl', {
        url : to.path,
      })
        .then(resp => resp.data)
        .then(data => {
          let route = {
            // ninjaPath : to.path, // no need for ninja if next landing
          }
          route.path = '/forceLanding'

          if (data.url) {
            let url = data.url
            route.ninjaPath = to.path
            route.path = `/${url}`

            if (url.charAt(0) === '/') route.path = url
          }

          next(route)
        })
        .catch(() => {
          next({ path: '/forceLanding' })
        })
    },
  },
]
